import { i18n } from '@lingui/core';
import { compileMessage } from '@lingui/message-utils/compileMessage';
import { loadDictionary as loadUrcDictionary } from '@upgrade/react-components';
import { loadDictionaries } from '@upgrade/react-components/DictionariesLoader';

// Import the locale caalogs
import enUSMessages from '../locales/en-US.json';
import enCAMessages from '../locales/en-CA.json';
import frCAMessages from '../locales/fr-CA.json';

// Import moment catalogs
import 'moment/locale/en-ca';
import 'moment/locale/fr-ca';

/**
 * We set the message compiler here because lingui excludes it in production builds.
 * However, we need it because upgrade libraries come pre-bundled with uncompiled messages.
 */
i18n.setMessagesCompiler(compileMessage);

const DEFAULT_LOCALE = 'en-US';
export const DICTIONARY_LOADERS = [loadUrcDictionary];

// Load all catalogs
i18n.load({
  'en-US': enUSMessages,
  'en-CA': enCAMessages,
  'fr-CA': frCAMessages
});

loadDictionaries({ i18n, locale: DEFAULT_LOCALE, dictionaryLoaders: DICTIONARY_LOADERS }).then(() => {
  i18n.activate(DEFAULT_LOCALE);
});

export const activateLocale = async (locale = 'en-US') => {
  i18n.activate(locale);
};

export default i18n;
